import { render, staticRenderFns } from "./SolutionPage.vue?vue&type=template&id=3656e6a4"
import script from "./SolutionPage.vue?vue&type=script&lang=js"
export * from "./SolutionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports